<!-- 标签页组件 -->
<template>
    <div class="c-tabs">
        <Tabs v-model="Xscj" :animated="false" @on-click="callbackReq">
            <TabPane v-for="item in xscjOption" :label="item.xscj" :name="item.cjbm" :key="item.id">
                <!-- :disabled="item.id == 1"> -->
                <!-- 标签一的内容 -->
            </TabPane>
        </Tabs>
    </div>
</template>

<script>
    export default {
        name: 'CTabs',
        props: {
            // 行使层级
            xscjOption: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        data() {
            return {
                // 行使层级选中值
                Xscj: '02'
            }
        },
        computed: {

        },
        mounted() {

        },
        methods: {
            // 返回参数,返回tabs组件参数给父组件VNav
            callbackReq() {
                this.$emit("buildAccrualListReqLv2", this.Xscj, 'xscj');
            }
        }
    }
</script>

<style scoped>

</style>